import {
  DeltaText,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

export const STRING_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'workflow-string-change',
  priority: -1,
  predicate: ({ change }) => change.fieldType === 'string',
  render: ({ change }) => (
    <DeltaText
      oldText={change.oldValue ?? ''}
      newText={change.newValue ?? ''}
      disableDiff
    />
  ),
});
